import type { ReactNode } from 'react';

import { Card, CardAction, CardContent, CardHeader } from '../../../ui/card';
import { ProvenanceStrip, type ProvenanceStripProps } from '../shared/ProvenanceStrip';

/** The frame every card on the screen shares: a heading, an optional chip
 *  beside it, and the card's own content. The heading is an `h2` so the page's
 *  outline lists the cards.
 *
 *  `provenance` is only ever set by the assistant's card dispatcher
 *  (`assistant/cards.ts`): on the figure's own screen the link would point at
 *  the page it is already on, so every direct caller here leaves it unset. */
export function SentimentCard(props: {
  title: string;
  aside?: ReactNode;
  children: ReactNode;
  provenance?: ProvenanceStripProps;
}): ReactNode {
  return (
    <Card>
      <CardHeader>
        <h2 className="text-title-sm">{props.title}</h2>
        {props.aside !== undefined && <CardAction>{props.aside}</CardAction>}
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {props.children}
        {props.provenance !== undefined && <ProvenanceStrip {...props.provenance} />}
      </CardContent>
    </Card>
  );
}
